import { call, put, takeLatest, cancelled } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../../../services/apis";

function* handleUploadBulkOrder(action) {
  try {
    const { email } = action.payload;
    // to avoid Redux serialization issue
    const file = window.__bulkOrderFile;
    if (!file) {
      throw new Error("No file selected");
    }
    
    const response = yield call(API.uploadBulkOrders, {
      file,
      email,
    });
    
    const responseData = response?.data;
    
    // Clean up file reference
    delete window.__bulkOrderFile;
    
    yield put(actions.uploadBulkOrderSuccess(responseData));
   
  } catch (error) {
    // Clean up file reference on error
    delete window.__bulkOrderFile;
    
    if (yield cancelled()) {
      return;
    }
    
    const errorData = error?.response?.data;
    const errorMessage = errorData?.message || error.message || "Failed to upload bulk orders";
    
    yield put(actions.uploadBulkOrderFailure({
      message: errorMessage,
      data: errorData?.data, 
      response: errorData
    }));
  }
}

export function* bulkOrderSaga() {
  yield takeLatest(actions.uploadBulkOrder.type, handleUploadBulkOrder);
}